import React, { useEffect, useMemo, useState } from "react";

export const read = (key: string): any => {
	if (typeof window === "undefined" || typeof window?.sessionStorage === "undefined") {
		return undefined;
	}
	const res = sessionStorage.getItem(key);
	if (res == null) {
		return undefined;
	}
	return JSON.parse(res);
};
export const write = (key: string, item: any) => {
	if (typeof item === "undefined") {
		return;
	}
	try {
		sessionStorage.setItem(key, JSON.stringify(item));
	} catch (e) {
		console.error("An error occurred while writing to session storage:", e);
	}
};

function useSession<T, S = T>(
	key: string,
	initialState: T | undefined = undefined,
	map?: (a: T | S) => T
): [T, React.Dispatch<React.SetStateAction<T>>] {
	const stored = useMemo(() => read(key), [key]);
	const [item, setItem] = useState<T>(stored === undefined ? initialState : stored);

	useEffect(() => {
		write(key, item);
	}, [item, key]);

	const resolvedT = useMemo(() => map?.(item) ?? item, [item, map]);
	return [resolvedT, setItem];
}

export default useSession;
